import DashboardLayout from "../../layouts/DashboardLayout";
import VideoCallSettingsCard from "../../components/admin/VideoCallSettingsCard";

export default function AdminVideoCall() {
  return (
    <DashboardLayout>
      <div className="container mx-auto p-4 md:p-8">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Video Call</h1>
          <p className="text-sm text-gray-500 mt-1">
            Configure video calling providers, enable or disable tools, and define the fallback chain for online appointments.
          </p>
        </div>

        <VideoCallSettingsCard />
      </div>
    </DashboardLayout>
  );
}
